<template>
  <NuxtLayout>
    <h2 class="mb-6" v-if="eventData?.event_tagline">{{ eventData?.event_tagline }}</h2>
    <div class="mb-6" v-html="eventData?.content_dynamic_body"></div>
    <v-row
      no-gutters
      v-if="
        eventData?.promotional_information?.speaker_name ||
        eventData?.promotional_information?.master_of_ceremony_name
      "
    >
      <v-col style="border: 1px solid #cacaca" class="pa-3">
        <div v-if="eventData?.promotional_information?.speaker_name">
          <p class="mb-3" style="color: var(--fundeasy-colors-neutral-500); font-weight: bold">
            Speaker
          </p>
          <v-divider class="mb-4"></v-divider>
          <p class="mb-4">{{ eventData?.promotional_information?.speaker_name }}</p>
        </div>
        <div class="mb-4" v-html="eventData?.promotional_information?.speaker_description"></div>
        <div v-if="eventData?.promotional_information?.master_of_ceremony_name">
          <p class="mb-3" style="color: var(--fundeasy-colors-neutral-500); font-weight: bold">
            Master of Ceremonies
          </p>
          <v-divider class="mb-4"></v-divider>
          <p>{{ eventData?.promotional_information?.master_of_ceremony_name }}</p>
        </div>
      </v-col>
      <v-divider class="mb-4"></v-divider>
    </v-row>
    <v-row
      v-if="
        !eventData?.location_details?.isVirtual &&
        (displayAddress || eventData?.location_details?.venue_name)
      "
      class="border rounded mb-12"
      no-gutters
    >
      <div class="w-100">
        <img
          v-if="eventData?.location_details?.maps_img && eventData?.location_details?.show_map"
          class=""
          style="width: 100%; height: auto"
          :src="eventData?.location_details?.maps_img"
          alt="location map"
        />
        <div class="pa-6 d-flex justify-space-between text-wrap flex-wrap">
          <div style="min-width: 50%" v-if="eventData?.location_details?.venue_name">
            <div class="mb-2 d-flex">
              <v-icon color="grey" class="mr-2" icon="mdi-map-marker-outline"></v-icon>
              <p style="font-weight: bold">Venue Name</p>
            </div>
            <p style="color: var(--fundeasy-colors-neutral-500)">
              {{ eventData?.location_details?.venue_name }}
            </p>
          </div>
          <div style="min-width: 50%" v-if="displayAddress">
            <div class="mb-2 d-flex">
              <v-icon color="grey" class="mr-2" icon="mdi-map-marker-outline"></v-icon>
              <p style="font-weight: bold">Venue Location</p>
            </div>
            <a
              class="d-inline-block w-100 break-words text-pre-line"
              :href="`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(displayAddress)}`"
              target="_blank"
              >{{ displayAddress }}</a
            >
          </div>
        </div>
        <div
          v-if="eventData?.location_details?.parking_instructions"
          class="pa-6 d-flex justify-space-between text-wrap flex-wrap"
        >
          <div style="min-width: 50%">
            <div class="mb-2 d-flex">
              <p style="color: var(--fundeasy-colors-neutral-500)">
                {{ eventData?.location_details?.parking_instructions }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </v-row>
    <SponsorDisplay />
  </NuxtLayout>
</template>

<script setup>
import useEventDataStore from '@/stores/eventDataStore';
import { computed } from 'vue';
import SponsorDisplay from '../../../components/sponsor/SponsorDisplay.vue';

const { eventData } = storeToRefs(useEventDataStore());
const displayAddress = computed(() => {
  const { address_1, address_2, city, state, postal_code, country } =
    eventData.value?.location_details || {};

  const addressParts = [address_1, address_2, city, state, postal_code, country];

  return addressParts.filter((part) => part).join(', ');
});
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
